import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.8615 6C12.4138 6 12.8615 6.44772 12.8615 7V11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H12.8615V17C12.8615 17.5523 12.4138 18 11.8615 18C11.3093 18 10.8615 17.5523 10.8615 17V13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H10.8615V7C10.8615 6.44772 11.3093 6 11.8615 6Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol